// extracted by mini-css-extract-plugin
export default {"step_desc":"step-desc_step_desc__gqN6r","step":"step-desc_step__AkPmz","desc":"step-desc_desc__MMyU4"};